import React, { useEffect, useState } from 'react'
import { Icon } from 'camino-react'

import {
  cloudhelpGet,
  cloudhelpDelete,
  cloudhelpPost
} from 'Utilities/CloudHelp'
import { filter } from 'lodash'

const Tags = ({ ticketID, allTicketTags }) => {
  const [name, setName] = useState('')
  const [ticketTags, setTicketTags] = useState([])
  const [allTag, setAllTags] = useState([])
  const [expanded, setExpanded] = useState(false)

  useEffect(() => {
    setTicketTags(filter(allTicketTags, tag => tag.ticket_id === ticketID))
  }, [])

  const getTags = () => {
    cloudhelpGet('/api/tags').then(res => setAllTags(res.data))
  }

  const getTicketTags = () => {
    cloudhelpGet('/api/ticket_tags')
      .then(res => setTicketTags(res.data.filter(d => d.ticket_id === ticketID)))
  }

  const removeTicketTag = (tag) => {
    cloudhelpDelete(`/api/ticket_tags/${tag.id}`)
      .then(getTicketTags)
      .catch(e => console.log(e))
  }

  const removeTag = (tag) => {
    if (!confirm('Are you sure you want to delete this tag?')) return

    cloudhelpDelete(`/api/tags/${tag.id}`)
      .then(getTags)
      .catch(e => console.log(e))
  }

  const createTag = () => {
    cloudhelpPost('/api/tags', { name })
      .then(() => {
        cloudhelpGet('/api/tags')
          .then((res) => {
            setAllTags(res.data)

            const newTag = res.data.find(a => a.name === name)
            createTicketTag(newTag, { id: ticketID })
          })
      })
      .catch(res => console.log(res))
  }

  const createTicketTag = (tag, ticket) => {
    const data = {
      tag_id: tag.id,
      ticket_id: ticket.id
    }

    cloudhelpPost('/api/ticket_tags', data)
      .then(() => {
        getTicketTags()
      })
      .catch(res => console.log(res))
  }

  const handleExpanded = () => {
    getTags()
    setExpanded(!expanded)
  }

  const useOutsideClick = (callback) => {
    const ref = React.useRef()

    React.useEffect(() => {
      const handleClick = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
          callback()
        }
      }

      document.addEventListener('click', handleClick, true)

      return () => {
        document.removeEventListener('click', handleClick, true)
      }
    }, [ref])

    return ref
  }

  const ref = useOutsideClick(() => setExpanded(false))

  const handleEnterKey = (e) => {
    if (e.key === 'Enter') createTag()
    if (e.key === 'Escape') setExpanded(false)
  }

  return (
    <div className="z-10 z-200">
      <div className="flex font-semibold text-xl p-1">
        <div className="flex flex-wrap">
          {ticketTags.map(tag => (
            <div key={tag.id} className="bg-gray-200 flex text-gray-600 rounded items-center py-1 px-2 mr-2 my-1">
              <div className="mr-1">{tag.tag_name}</div>

              <button
                className="flex items-center justify-center w-7 h-7 cursor-pointer duration-300 hover:bg-gray-300 rounded-full"
                onClick={() => removeTicketTag(tag)}
                type="button"
              >
                <Icon type="cross" />
              </button>
            </div>
          ))}

          <button
            className="bg-gray-200 font-semibold text-4xl cursor-pointer mt-1 flex items-center justify-center w-9 h-9 rounded duration-300 text-gray-400 hover:bg-gray-300 hover:text-gray-500"
            type="button"
            onClick={handleExpanded}
          >
            +
          </button>
        </div>
      </div>

      <div ref={ref} className={`${!expanded ? 'hidden' : 'flex'} shadow absolute bg-white flex-col border border-gray-200 rounded p-3 z-10`}>
        <div className="border border-gray-300 rounded p-2 text-xl">
          <Icon type="magnifier" />

          <input
            className="px-2 focus:outline-none w-64"
            type="text"
            value={name}
            onChange={e => setName(e.target.value)}
            placeholder="Find or create tag"
            onKeyDown={handleEnterKey}
          />
        </div>

        <div className="w-full mt-2 flex flex-col text-gray-700 font-semibold">
          {allTag.filter(tag => !ticketTags.map(tt => tt.tag_name).includes(tag.name)).filter(tag => tag.name.toLowerCase().includes(name.toLowerCase())).map(tag => (
            <div className="flex items-center justify-between">
              <button
                onClick={() => createTicketTag(tag, { id: ticketID })}
                className="flex-1 cursor-pointer p-2 duration-300 hover:bg-gray-100 rounded-ms mr-2 text-left font-semibold"
                type="button"
              >
                {tag.name}
              </button>

              <button
                type="button"
                onClick={() => removeTag(tag)}
                className="p-1 w-8 h-8 duration-300 rounded-full text-gray-400 hover:bg-gray-200"
              >
                <Icon type="cross" />
              </button>
            </div>
          ))}

          {(!allTag.map(tag => tag.name).includes(name) && !!name) && (
            <button
              className="cursor-pointer text-left p-2 duration-300 hover:bg-gray-100 rounded"
              onClick={createTag}
              type="button"
            >
              <span className="text-gray-400">Create </span>
              <span className="font-semibold">{name}</span>
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default Tags
